// import 'svgxuse';
import smoothscroll from 'smoothscroll-polyfill';
import Alpine from 'alpinejs';
import Lightbox from '@edsardio/alpine-lightbox';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import a11ygallery from './a11ygallery';
import a11ymenu from './a11ymenu.js';
import a11ydropdown from './a11ydropdown.js';
import a11ycarousel from './a11ycarousel.js';
import a11ycookieconsent from './a11ycookieconsent';
import a11ycollapse from './a11ycollapse';
import { Loader } from '@googlemaps/js-api-loader';
import 'element-closest-polyfill';

// import resolveConfig from 'tailwindcss/resolveConfig';
//
// const tailwindConfig = require('../../tailwind.config.js');
// const fullConfig = resolveConfig(tailwindConfig);
// console.log(fullConfig);

smoothscroll.polyfill();

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(Lightbox);
Alpine.data('a11ygallery', a11ygallery);
Alpine.data('a11ymenu', a11ymenu);
Alpine.data('a11ydropdown', a11ydropdown);
Alpine.data('a11ycarousel', a11ycarousel);
Alpine.data('a11ycookieconsent', a11ycookieconsent);
Alpine.data('a11ycollapse', a11ycollapse);
Alpine.start();

const loader = new Loader({
    apiKey: 'AIzaSyBF7nfnQbCQb4cMPXbuLTi6MfNcDTKJaKk',
    version: 'weekly',
    libraries: ['places'],
});

loader
    .load()
    .then((google) => {
        const mapElement = document.getElementById('contactsGoogleMap');
        if (mapElement) {
            const mapOptions = {
                mapId: 'a8e7d83630a1e301',
                zoom: 16,
                mapTypeId: 'roadmap',
                // mapTypeControlOptions: {
                //     mapTypeIds: ["roadmap", "satellite", "hybrid", "terrain", "a8e7d83630a1e301"],
                // },
                center: { lat: 50.1791277, lng: 14.4180443 },
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: true,
                streetViewControl: true,
                rotateControl: true,
                fullscreenControl: true,
            };
            const googleMap = new google.maps.Map(mapElement, mapOptions);
            // googleMap.mapTypes.set("styled_map", styledMapType);
            // googleMap.setMapTypeId("styled_map");
        }
    })
    .catch((e) => {
        console.log('Google map init error.');
    });
